import React, { useState } from 'react';
import AddYoutubeUrl from './AddYoutubeUrl';
import { upload } from '../../../api/sportaloka-client';
import Swal from 'sweetalert2';
const TenantMedia = ({ index, handleMediaChange, isEditable, loading, value, type }) => {
  const [uploadLoading, setUploadLoading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    e.target.value = '';
    if (selectedFile) {
      handleUpload(selectedFile);
    }
  };

  const handleUpload = async (file) => {
    if (!file) {
      Swal.fire({
        title: 'Gagal!',
        text: `Harap memilih file`,
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('path', 'tenant/profile/media/');

    try {
      setUploadLoading(true);
      const response = await upload(formData);
      handleMediaChange(response.data.data.url, index, 'IMAGE');
      setUploadLoading(false);
    } catch (error) {
      Swal.fire({
        title: 'Gagal!',
        text: `Periksa koneksi internet anda dan coba kembali`,
        icon: 'error',
        confirmButtonText: 'Tutup'
      });
      setUploadLoading(false);
    }
  };

  const handleRemove = () => {
    handleMediaChange('', index, 'IMAGE');
  };

  return (
    <div className={`tenant-media ${loading || (!isEditable && 'pe-none opacity-50')}`}>
      <div className="tenant-media__selector">
        {uploadLoading && <div className="fw-500">Uploading...</div>}
        {value && !uploadLoading && (
          <div className="m-0 p-0 overflow-hidden position-relative d-flex flex-column align-items-center justify-content-center">
            {type === 'IMAGE' ? (
              <a href={value} className="mb-10" target="_blank" rel="noreferrer">
                <img
                  src={value}
                  className="img-fluid"
                  style={{ height: 120, objectFit: 'cover', objectPosition: 'center' }}
                />
              </a>
            ) : (
              <iframe
                style={{ height: 120, width: '100%' }}
                className="overflow-hidden"
                src={value}
              />
            )}
            <div className="text-center mt-20 mb-0">
              <button type="button" onClick={handleRemove} className="btn btn-danger btn-sm m-0">
                <i className="fa fa-trash text-18 mr-5" /> Remove
              </button>
            </div>
          </div>
        )}
        {!value && !uploadLoading && (
          <div className="d-flex justify-content-center flex-column">
            <button
              type="button"
              onClick={() => document.getElementById(`tenantMediaUploader-${index}`).click()}
              disabled={!isEditable || loading}>
              <i className="fa fa-image mr-5"></i>Image
            </button>
            <input
              accept="image/*"
              type="file"
              onChange={handleFileChange}
              id={`tenantMediaUploader-${index}`}
              style={{ display: 'none' }}
            />
            <button
              disabled={!isEditable || loading}
              type="button"
              data-bs-toggle="modal"
              data-bs-target={`#addYoutubeUrlModal-${index}`}>
              <i className="fa fa-youtube-play mr-5"></i>
              Youtube link
            </button>
          </div>
        )}
      </div>
      <AddYoutubeUrl
        onAdded={(val, index) => handleMediaChange(val, index, 'YOUTUBE_URL')}
        index={index}
      />
    </div>
  );
};

export default TenantMedia;
